<div class="contactus-container">
  <div class="contactus-content">

    <!-- ── Header ── -->
    <div class="list-header">
      <h5>{{ selectedProduct ? selectedProduct.label + ' - Leads' : 'Leads' }}</h5>

      <div class="list-actions">

        <!-- Product Dropdown -->
        <div class="product-dropdown-wrapper">
          <div class="input-group custom-dropdown" [class.dropdown-open]="isProductDropdownOpen">

            <span class="input-group-text bg-transparent icon-prefix">
              <i class="bi bi-grid-3x3-gap"></i>
            </span>

            <div class="form-control dropdown-trigger"
                 (click)="toggleProductDropdown()">
              <span class="trigger-label">
                {{ selectedProduct ? selectedProduct.label : (isProductsLoading ? 'Loading...' : 'Select Product') }}
              </span>
              <i class="bi dropdown-arrow"
                 [ngClass]="isProductDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>

            <span class="input-group-text bg-transparent clear-btn-wrap"
                  *ngIf="selectedProduct"
                  (click)="clearProductFilter()"
                  style="cursor:pointer;">
              <i class="bi bi-x-circle"></i>
            </span>

            <!-- Dropdown Menu -->
            <div class="cdd-menu" *ngIf="isProductDropdownOpen">
              <div class="cdd-search-hint" *ngIf="isProductsLoading">
                <i class="bi bi-hourglass-split me-2"></i> Loading products...
              </div>
              <ng-container *ngIf="!isProductsLoading">
                <div class="cdd-option"
                     *ngFor="let product of products"
                     [ngClass]="{'cdd-option-active': selectedProduct?.key === product.key}"
                     (click)="selectProduct(product)">
                  <i class="bi bi-check cdd-check"></i>
                  {{ product.label }}
                </div>
                <div class="cdd-empty" *ngIf="products.length === 0">
                  No products available
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Search Box — only shown after product is selected -->
        <div class="search-box" *ngIf="selectedProduct">
          <div class="input-group">
            <span class="input-group-text bg-transparent" style="border: 0px !important">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              style="padding: 0px !important; border: 0px !important"
              placeholder="Search by name, email, phone..."
              [(ngModel)]="searchQuery"
              (input)="onSearch()"
              (keyup.enter)="onSearch()">
            <span class="input-group-text bg-transparent clear-btn-wrap"
                  *ngIf="searchQuery"
                  (click)="clearSearch()"
                  style="cursor:pointer;">
              <i class="bi bi-x-circle"></i>
            </span>
          </div>
        </div>

        <!-- Clear Filter button -->
        <button class="btn clear-filter-btn"
                *ngIf="selectedProduct"
                (click)="clearProductFilter()">
          Clear Filter
        </button>

      </div>
    </div>

    <!-- ── Search result count ── -->
    <div class="results-count" *ngIf="selectedProduct && !isLoading && dataSource.length > 0">
      {{ getTotalLeadsLabel() }}
    </div>

    <!-- ── Table ── -->
    <div class="leads-table" [class.loading]="isLoading"
         *ngIf="selectedProduct && dataSource.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('firmname')">
              Firm Name <i class="bi sort-icon" [ngClass]="getSortIcon('firmname')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('person')">
              Contact Person <i class="bi sort-icon" [ngClass]="getSortIcon('person')"></i>
            </th>
            <th class="thdata sortable-col hide-md" scope="col" (click)="sortBy('email')">
              Email <i class="bi sort-icon" [ngClass]="getSortIcon('email')"></i>
            </th>
            <th class="thdata hide-md" scope="col">Phone</th>
            <th class="thdata hide-lg" scope="col">Country</th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('createdAt')">
              Enrolled On <i class="bi sort-icon" [ngClass]="getSortIcon('createdAt')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let lead of getPage()">
            <td>
              <div class="firm-name">
                <span class="firm-avatar">{{ getInitials(lead.firmname) }}</span>
                <span>{{ lead.firmname || '-' }}</span>
              </div>
            </td>
            <td>{{ lead.person || '-' }}</td>
            <td class="hide-md email-cell">
              <a *ngIf="lead.email" [href]="'mailto:' + lead.email" class="email-link">
                {{ lead.email }}
              </a>
              <span *ngIf="!lead.email">-</span>
            </td>
            <td class="hide-md">{{ lead.phone || '-' }}</td>
            <td class="hide-lg">{{ lead.country || '-' }}</td>
            <td>{{ lead.createdAt || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Skeleton loader ── -->
    <div *ngIf="isLoading" class="skeleton-wrapper">
      <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7]">
        <div class="skeleton-cell avatar-cell"></div>
        <div class="skeleton-cell wide"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell wide hide-md"></div>
        <div class="skeleton-cell medium hide-md"></div>
        <div class="skeleton-cell short hide-lg"></div>
        <div class="skeleton-cell medium"></div>
      </div>
    </div>

    <!-- ── Empty states ── -->
    <div *ngIf="!selectedProduct && !isLoading" class="empty-state">
      <i class="bi bi-layers empty-icon"></i>
      <p class="empty-title">Select a Product</p>
      <p class="empty-sub">Choose a product from the dropdown above to view its leads.</p>
    </div>

    <div *ngIf="selectedProduct && !isLoading && dataSource.length === 0" class="empty-state">
      <i class="bi bi-inbox empty-icon"></i>
      <p class="empty-title">No Leads Found</p>
      <p class="empty-sub">
        {{ searchQuery ? 'No results match your search.' : 'No leads available for ' + selectedProduct.label + '.' }}
      </p>
    </div>

    <!-- ── Pagination ── -->
    <div class="pagination-area" *ngIf="selectedProduct && dataSource.length > 0">
      <div class="pagination-info">{{ getPaginationRange() }}</div>
      <nav aria-label="Leads pagination">
        <ul class="pagination mb-0">
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToFirstPage()">
              <i class="bi bi-chevron-double-left biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToPrevPage()">
              <i class="bi bi-chevron-left biarr"></i> Previous
            </a>
          </li>
          <li *ngFor="let page of getPageNumbers()" class="page-item"
              [ngClass]="{'active': page === pageIndex + 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToPage(page - 1)">{{ page }}</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToNextPage()">
              Next <i class="bi bi-chevron-right biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToLastPage()">
              <i class="bi bi-chevron-double-right biarr"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>

  </div>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>